import React from 'react'
import { ListGroup, ListGroupItem } from 'reactstrap'
import currency from 'i18n/currency'
import { useTranslation } from 'react-i18next'
import { isMobile } from 'react-device-detect'
import {get} from 'lodash'

const PriceSummary = ({ machine }) => {
  const { i18n } = useTranslation()
  const [current] = machine
  const { priceSummary } = current.context
  const stepPrices = Object.values(priceSummary || {})
  const cur = get(current.context, 'currency', 'EUR')

  if (stepPrices.length === 0) return null

  const total_base_price = stepPrices
    .map((p) => p.base_price)
    .reduce((acc, val) => currency(acc, cur).add(val))
  const total_discount = stepPrices
    .map((p) => p.discount)
    .reduce((acc, val) => currency(acc, cur).add(val))
  const total_additional_fee = stepPrices
    .map((p) => p.additional_fee)
    .reduce((acc, val) => currency(acc, cur).add(val))
  const total_final_price = stepPrices
    .map((p) => p.total_price)
    .reduce((acc, val) => currency(acc, cur).add(val))

  const showBase = total_base_price.value !== total_final_price.value
  const showDiscount = total_discount.value !== 0
  const showFee = total_additional_fee.value !== 0

  return (
    <ListGroup>
      {showBase && (
        <ListGroupItem className="d-flex justify-content-between">
          <span>{i18n.t('price_summary.base_price')}</span>
          <span>{total_base_price.format()}</span>
        </ListGroupItem>
      )}

      {showDiscount && (
        <ListGroupItem className="d-flex justify-content-between text-success">
          <span>{i18n.t('price_summary.discount')}</span>
          <span>-{total_discount.format()}</span>
        </ListGroupItem>
      )}

      {showFee && (
        <ListGroupItem className="d-flex justify-content-between text-secondary">
          <span>{i18n.t('price_summary.additional_fee')}</span>
          <span>{total_additional_fee.format()}</span>
        </ListGroupItem>
      )}

      <ListGroupItem className="d-flex justify-content-between bg-light fw-bold h5 m-0">
        <span>{i18n.t('price_summary.total_price')}</span>
        <span className="text-danger">{total_final_price.format()}</span>
      </ListGroupItem>
    </ListGroup>
  )
}

export default PriceSummary
